'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

var React = require('react');
var Header = require('../Header/Header.js');
var Input = require('../../Input/Input.js');
var Radio = require('../../Radio/Radio.js');
var RadioGroup = require('../../RadioGroup/RadioGroup.js');
var DropDown = require('../../DropDown/DropDown.js');
var Checkbox = require('../../Checkbox/Checkbox.js');
var Button = require('../../Button/Button.js');
var Login = require('../Login.js');
var dates = require('../../../utils/dates.js');
require('./Registration.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var Registration = function () {
    var _a = Login.useLoginContext(), errorMessage = _a.errorMessage, backToPrev = _a.backToPrev, handleRegister = _a.handleRegister;
    var _b = React.useState(false), agreedTerm = _b[0], setAgreedTerm = _b[1];
    var _c = React.useState(''), password = _c[0], setPassword = _c[1];
    var _d = React.useState(''), rePassword = _d[0], setRePassword = _d[1];
    var _e = React.useState(), validationError = _e[0], setValidationError = _e[1];
    var handleSubmit = function (e) {
        e.preventDefault();
        var _a = e.target, fullname = _a.fullname, gender = _a.gender, date = _a.date, month = _a.month, year = _a.year, phone = _a.phone;
        var payload = {
            fullname: fullname.value,
            gender: gender.value,
            date: date.value,
            month: month.value,
            year: year.value,
            phone: phone.value,
            password: password,
            repassword: rePassword
        };
        handleRegister(payload);
    };
    var handlePasswordChange = function (passwordValue) {
        setValidationError({ password: null });
        setPassword(passwordValue);
        var passwordRegx = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{8,}$/;
        var passwordTest = passwordRegx.test(passwordValue);
        if (!passwordTest) {
            setValidationError({ password: 'Kata sandi minimal 8 karakter, menggunakan huruf besar, huruf kecil, angka, dan minimal 1 karakter simbol.' });
        }
    };
    var handleRepasswordChange = function (repasswordValue) {
        setValidationError({ repassword: null });
        setRePassword(repasswordValue);
        if (!repasswordValue || repasswordValue.length <= 0 || repasswordValue === password) {
            return;
        }
        setValidationError({ repassword: 'Konfirmasi Password tidak sama.' });
    };
    return (React__default['default'].createElement("div", { className: 'registration__background' },
        React__default['default'].createElement("div", { className: 'registration__box' },
            React__default['default'].createElement(Header, { isModal: true, showBackBtn: true, onBackBtnClick: function () { return backToPrev('login'); } }),
            React__default['default'].createElement("form", { onSubmit: handleSubmit },
                React__default['default'].createElement("div", { className: 'field' },
                    React__default['default'].createElement("div", { className: 'field__text' },
                        React__default['default'].createElement(Input.Input, { name: 'fullname', type: 'text', inputMode: 'text', placeholder: 'Nama Lengkap', onChange: function () { }, size: 'md', error: errorMessage && errorMessage.fullname }))),
                React__default['default'].createElement("div", { className: 'field' },
                    React__default['default'].createElement("label", { htmlFor: 'gender', className: 'gender__label' }, "Jenis Kelamin"),
                    React__default['default'].createElement(RadioGroup.RadioGroup, { id: 'radio__group__wrap', groupAlignment: 'horizontal' },
                        React__default['default'].createElement(Radio.Radio, { id: 'gender', name: 'gender', labelName: 'Pria', value: 'MALE', handleOnChange: function () { } }),
                        React__default['default'].createElement(Radio.Radio, { id: 'gender', name: 'gender', labelName: 'Wanita', value: 'FEMALE', handleOnChange: function () { } })),
                    errorMessage && errorMessage.gender && React__default['default'].createElement("span", { className: 'error-msg' }, errorMessage.gender)),
                React__default['default'].createElement("div", { className: 'field' },
                    React__default['default'].createElement("label", { htmlFor: 'birthdate', className: 'birthdate__label' }, "Tanggal Lahir"),
                    React__default['default'].createElement("div", { className: 'field__birthdate' },
                        React__default['default'].createElement(DropDown.DropDown, { id: 'date', name: 'date', list: dates.dateList }),
                        React__default['default'].createElement(DropDown.DropDown, { id: 'month', name: 'month', list: dates.monthList }),
                        React__default['default'].createElement(DropDown.DropDown, { id: 'year', name: 'year', list: dates.getYearList() }))),
                React__default['default'].createElement("div", { className: 'field' },
                    React__default['default'].createElement("div", { className: 'field__text' },
                        React__default['default'].createElement(Input.Input, { name: 'phone', type: 'tel', inputMode: 'tel', placeholder: 'Nomor Telepon', onChange: function () { }, size: 'md', error: errorMessage && errorMessage.phoneNumber }))),
                React__default['default'].createElement("div", { className: 'field' },
                    React__default['default'].createElement("div", { className: 'field__text' },
                        React__default['default'].createElement(Input.Input, { name: 'password', type: 'password', inputMode: 'text', placeholder: 'Password', value: password, onChange: function (e) { return handlePasswordChange(e.target.value); }, size: 'md', error: (validationError && validationError.password) || (errorMessage && errorMessage.password) }))),
                React__default['default'].createElement("div", { className: 'field' },
                    React__default['default'].createElement("div", { className: 'field__text' },
                        React__default['default'].createElement(Input.Input, { name: 'repassword', type: 'password', inputMode: 'text', placeholder: 'Konfirmasi Password', value: rePassword, onChange: function (e) { return handleRepasswordChange(e.target.value); }, size: 'md', error: (validationError && validationError.repassword) || (errorMessage && errorMessage.repassword) }))),
                React__default['default'].createElement("div", { className: 'field' },
                    React__default['default'].createElement("div", { className: 'field__term' },
                        React__default['default'].createElement(Checkbox.Checkbox, { id: 'tc_checkbox', labelName: '', labelHidden: false, onChange: function () { return setAgreedTerm(!agreedTerm); } }),
                        React__default['default'].createElement("span", null,
                            "Saya setuju dengan ",
                            React__default['default'].createElement("a", { href: '/ketentuan/' }, "Kebijakan Pengunaan"),
                            "  Lifepal "))),
                React__default['default'].createElement(Button.Button, { variant: 'primary', id: 'regis-btn', type: 'submit', isBlock: true, disabled: !agreedTerm, className: 'action-button bottom-16p', onClick: function () { } }, "Daftar")))));
};

module.exports = Registration;
//# sourceMappingURL=Registration.js.map
